// Returns true for a single printable character (incl. Space) without modifiers; used as the quick-filter shortcut trigger so plain typing — or Space — opens the filter.
export const isPrintableTriggerKey = (event: KeyboardEvent): boolean => {
  if (event.ctrlKey || event.metaKey || event.altKey) return false;
  if (event.repeat) return false;
  if (event.key.length !== 1) return false;

  // Skip ASCII control chars and DEL; Space (0x20) is allowed because the shortcut treats it as a "just open, no inject" trigger.
  const charCode = event.key.charCodeAt(0);
  return charCode >= 0x20 && charCode !== 0x7f;
};
